// One sentence for the student, and whether a Retry is worth offering.
//
// A Retry that will fail again is worse than no button, so 503 offers none.
// 401 renders nothing at all: APIService already dispatches sessionExpired and
// the sign-in flow takes over.

export function taraFeedbackErrorCopy(error) {
  const status = error && error.status;
  const name = error && error.name;

  if (status === 401) return null;

  if (name === 'AbortError' || status === 502 || status === 504) {
    return {
      message: 'This is taking longer than expected. Your work is saved, so do try again.',
      retryable: true,
    };
  }
  if (status === 503) {
    return { message: 'Not available just yet.', retryable: false };
  }
  if (status === 429) {
    return { message: 'Too many requests just now. Try again in a minute.', retryable: true };
  }
  if (status === 404 && /no essay/i.test(String(error.data && error.data.error))) {
    return {
      message: 'No essay was saved on this sitting, so there is nothing to give feedback on.',
      retryable: false,
    };
  }
  if (status === 409) {
    return {
      message: error && error.data && error.data.error
        ? error.data.error
        : 'Run the previous section first.',
      retryable: false,
    };
  }
  return {
    message: 'Something went wrong generating this. Try again, or come back later.',
    retryable: true,
  };
}
